/* unplugin-vue-components disabled */import script from "./qr-code.vue?vue&type=script&setup=true&lang=js"
export * from "./qr-code.vue?vue&type=script&setup=true&lang=js"

import "./qr-code.vue?vue&type=style&index=0&id=6094f7e3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6094f7e3"]])

export default __exports__